/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/stop_medium'
export default icon
